module.exports = __webpack_public_path__ + "img/resolve the scarlet mist incident.a6b60505.png";